<style lang="stylus">
    .style-set-wrapper
        width 100%
        padding: 0 16px;
        .styleset-box
            margin-top 8px
            &.active
                .box-title
                    .item-icon
                        transform rotate(90deg)
                + .styleset-box
                    margin-top 16px
            .box-title
                border-top none
                height 40px
                display flex
                justify-content space-between
                align-items center
                p
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 18px;
                    text-align: left;
                    color var(--text-color-primary)
                .item-icon
                    width 16px;
                    height 16px
</style>

<template>
    <div class="style-set-wrapper" ref="box">
        <div class="styleset-box styleset-fillbox" :class="{ active: expandStyleList.includes('fill') }" ref="fillDom">
            <div class="box-title" @click="toggleExpand('fill')">
                <p>{{ $t("fill") }}</p>
                <iconSymbol name="leftpanel-right-arrow" class="item-icon" />
            </div>
            <collapseTransition>
                <div v-show="expandStyleList.includes('fill')">
                    <FillP @changeSet="() => trackStyleSet('fill')" />
                </div>
            </collapseTransition>
        </div>
        <div class="styleset-box styleset-linebox" :class="{ active: expandStyleList.includes('line') }" ref="lineDom">
            <div class="box-title" @click="toggleExpand('line')">
                <p>{{ $t("line") }}</p>
                <iconSymbol name="leftpanel-right-arrow" class="item-icon" />
            </div>
            <collapseTransition>
                <div v-show="expandStyleList.includes('line')">
                    <LineP @changeSet="() => trackStyleSet('line')" />
                </div>
            </collapseTransition>
        </div>
        <div class="styleset-box styleset-shadowbox" :class="{ active: expandStyleList.includes('shadow') }" ref="shadowDom">
            <div class="box-title" @click="toggleExpand('shadow')">
                <p>{{ $t("shadow") }}</p>
                <iconSymbol name="leftpanel-right-arrow" class="item-icon" />
            </div>
            <collapseTransition>
                <div v-show="expandStyleList.includes('shadow')">
                    <ShadowP @changeSet="() => trackStyleSet('shadow')" />
                </div>
            </collapseTransition>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import collapseTransition from "@/public/utils/collapse-transition.js";

    @Component({
        components: {
            collapseTransition,
            FillP: () => import("./FillPanel.vue"),
            LineP: () => import("./LinePanel.vue"),
            ShadowP: () => import("./ShadowPanel.vue"),
        },
    })
    export default class ShapePanel extends Vue {
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }

        toggleExpand(name) {
            let temp = [...this.expandStyleList];
            if (temp.includes(name)) {
                for (let i = 0; i < temp.length; i++) {
                    if (temp[i] == name) {
                        temp.splice(i, 1);
                        break;
                    }
                }
            } else {
                temp.push(name);
            }
            this.setStorage(temp);
            this.$store.commit("setStatus", { type: "expandStyleList", data: [...temp] });
        }

        get expandStyleList() {
            return this.$store.state.ui.expandStyleList;
        }

        getStorage() {
            let data = JSON.parse(localStorage.getItem("rightStylePanel")) || ["fill", "line", "shadow"];
            this.$store.commit("setStatus", { type: "expandStyleList", data });
        }
        setStorage(data) {
            localStorage.setItem("rightStylePanel", JSON.stringify(data));
        }

        trackStyleSet(type) {
            this.sensors.track("styleSet", {
                Catalogues: "rightMenu Bar",
                style_tab: type,
            });
        }

        scrollToLabel(type) {
            let dom;
            switch (type) {
                case "fill": {
                    dom = this.$refs.fillDom;
                    break;
                }
                case "line": {
                    dom = this.$refs.lineDom;
                    break;
                }
                case "shadow": {
                    dom = this.$refs.shadowDom;
                    break;
                }
            }
            const scroll = () => {
                dom && this.$emit("setScrollTop", dom.offsetTop);
            };
            if (this.expandStyleList.includes(type)) {
                scroll();
            } else {
                this.toggleExpand(type);
                this.$nextTick(() => {
                    scroll();
                });
            }
        }
        //生命周期
        mounted() {
            this.getStorage();
            this.$bus.$on("rightStylePanelScrollTo", this.scrollToLabel);
        }

        created() {}

        beforeDestroy() {
            this.$bus.$off("rightStylePanelScrollTo", this.scrollToLabel);
        }
    }
</script>
<i18n>
{
  "zh": {
      "fill": "填充",
      "line": "线条",
      "shadow": "阴影"
  },
  "en": {
      "fill": "Fill",
      "line": "Line",
      "shadow": "Shadow"
  },
  "fr": {
      "fill": "Remplir",
      "line": "Ligne",
      "shadow": "Ombre"
  },
  "de": {
      "fill": "Füllen",
      "line": "Linie",
      "shadow": "Schatten"
  },
  "jp": {
      "fill": "塗りつぶし",
      "line": "線",
      "shadow": "影"
  },
  "es": {
      "fill": "Llenar",
      "line": "Línea",
      "shadow": "Sombra"
  },
  "pt": {
      "fill": "Preenchimento",
      "line": "Linha",
      "shadow": "Sombra"
  },
  "it": {
      "fill": "Riempi",
      "line": "Linea",
      "shadow": "Ombra"
  },
  "tw": {
      "fill": "填充",
      "line": "線條",
      "shadow": "陰影"
  }
}
</i18n>
